/** @format */

import React from 'react';
import {InputWithErrorHandler} from 'frontier-form';
import ErrorDisplay from 'frontier/utilities/error';
import {ConditionalButton} from 'frontier-utilities';
import GoogleLoginButton from 'frontier/account/components/auth/google_login/google_signin_button';
import useLogin from 'frontier/account/components/auth/ajax_login/use_login';

export default function WorkrouterLoginContainer({redirect}) {
    const {
        username,
        password,
        onInputChange,
        onSubmitLogin,
        onKeyPress,
        isComplete,
        error,
        isAuthorizing
    } = useLogin({redirect});
    return (
        <div>
            {error && (
                <div className="alert alert-danger">
                    <ErrorDisplay error={error} />
                </div>
            )}
            <div className="form-group_field field">
                <InputWithErrorHandler
                    type="text"
                    name="username"
                    className="form-control control w-100"
                    value={username}
                    onChange={onInputChange.bind(this, 'username')}
                    onKeyUp={onKeyPress}
                    placeholder="Enter your Email*"
                />
            </div>

            <div className="form-group_field field">
                <InputWithErrorHandler
                    type="password"
                    name="password"
                    className="form-control control w-100"
                    value={password}
                    onChange={onInputChange.bind(this, 'password')}
                    onKeyUp={onKeyPress}
                    placeholder="Password*"
                />
            </div>
            <div className="d-flex justify-content-between align-items-center">
                <ConditionalButton enabled={isAuthorizing}>
                    <button
                        disabled="disabled"
                        className="btn btn--primary"
                        style={{fontSize: '20px'}}>
                        Authenticating....
                    </button>
                    <button
                        onClick={onSubmitLogin}
                        className="btn btn--primary"
                        style={{fontSize: '20px'}}>
                        Login
                    </button>
                </ConditionalButton>
                <GoogleLoginButton />
            </div>
        </div>
    );
}
